var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectionAttemptTimer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 1.16602C10.2217 1.16602 12.8333 3.7776 12.8333 6.99935C12.8333 10.2211 10.2217 12.8327 6.99996 12.8327C3.77821 12.8327 1.16663 10.2211 1.16663 6.99935H2.33329C2.33329 9.57652 4.42279 11.666 6.99996 11.666C9.57713 11.666 11.6666 9.57652 11.6666 6.99935C11.6666 4.42218 9.57713 2.33268 6.99996 2.33268C5.56263 2.33268 4.27696 2.98252 3.42121 4.00393L4.66663 5.24935H1.16663V1.74935L2.59404 3.17618C3.66329 1.94535 5.24063 1.16602 6.99996 1.16602ZM7.58329 4.08268V6.75727L9.47504 8.64902L8.64963 9.47443L6.41663 7.24027V4.08268H7.58329Z",
    fill: "#8A8894"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionAttemptTimer);
export default __webpack_public_path__ + "static/media/connection_attempt_timer.fa2181d1a7edbede1681c299f88cef57.svg";
export { ForwardRef as ReactComponent };